import { render, staticRenderFns } from "./RequisitesSimple.vue?vue&type=template&id=4699688c&scoped=true"
import script from "./RequisitesSimple.vue?vue&type=script&lang=js"
export * from "./RequisitesSimple.vue?vue&type=script&lang=js"
import style0 from "./RequisitesSimple.vue?vue&type=style&index=0&id=4699688c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4699688c",
  null
  
)

export default component.exports